import { Button } from '@noorden-insurtech/alba-design-system';
import type { BulkRunState } from '../hooks/use-bulk-broker-products.hook';

/** Mesmo teto de listagem de erro usado na edição em lote do balde. */
const MAX_LISTED_ERRORS = 20;

interface BulkProductsResultProps {
  state: BulkRunState;
  onRetryFailed: () => void;
}

export function BulkProductsResult({
  state,
  onRetryFailed,
}: BulkProductsResultProps) {
  const { totals, failures, globalErrors, cancelled, total, done } = state;
  const listed = failures.slice(0, MAX_LISTED_ERRORS);
  const overflow = failures.length - listed.length;

  return (
    <div className='flex flex-col gap-4 py-2'>
      {cancelled && (
        <p className='rounded-lg border border-alba-warning-orange-400 bg-alba-warning-orange-400/10 px-3 py-2 text-sm text-alba-gray-700'>
          Execução cancelada: {total - done} corretora(s) não foram processadas.
          O que já tinha sido enviado foi aplicado.
        </p>
      )}

      <div className='flex flex-wrap gap-x-6 gap-y-2 text-sm'>
        <span className='text-alba-gray-700'>
          Aplicados: <strong>{totals.updated}</strong>
        </span>
        {/* Sem `skipped` à vista, reaplicar uma operação já feita parece falha. */}
        <span className='text-alba-gray-700'>
          Já estavam assim: <strong>{totals.skipped}</strong>
        </span>
        <span
          className={
            totals.failed > 0 ? 'text-alba-error-red-500' : 'text-alba-gray-700'
          }
        >
          Com erro: <strong>{totals.failed}</strong>
        </span>
      </div>

      {globalErrors.length > 0 && (
        <ul className='flex flex-col gap-1 text-sm text-alba-error-red-500'>
          {[...new Set(globalErrors)].map(message => (
            <li key={message}>{message}</li>
          ))}
        </ul>
      )}

      {failures.length > 0 && (
        <div className='max-h-64 overflow-y-auto rounded-xl border border-alba-gray-200 p-3'>
          <ul className='flex flex-col gap-1 text-sm text-alba-gray-700'>
            {listed.map((failure, index) => (
              <li key={`${failure.brokerCode}-${index}`}>
                <strong>{failure.brokerName}</strong>
                {failure.productCodes.length > 0 &&
                  ` — ${failure.productCodes.join(', ')}`}
                : {failure.message}
              </li>
            ))}
          </ul>
          {overflow > 0 && (
            <p className='mt-2 text-xs text-alba-gray-600'>
              … e mais {overflow} erro(s).
            </p>
          )}
        </div>
      )}

      {failures.length > 0 && (
        <div>
          <Button variant='outline' onClick={onRetryFailed}>
            Tentar novamente as {failures.length} que falharam
          </Button>
        </div>
      )}

      {failures.length === 0 && globalErrors.length === 0 && !cancelled && (
        <p className='text-sm text-alba-gray-600'>
          Operação concluída sem erros.
        </p>
      )}
    </div>
  );
}
